import {
  AddOn,
  AvyInvoiceStatus,
  Elavtalsstatus,
  InvoiceDeliveryMethod,
  InvoiceStatus,
  PaymentStatus,
} from "../api/ApiClient";

export function thousandSeparator(value: number) {
  return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
}

export const addonToString = (addon: AddOn) => {
  switch (addon) {
    case AddOn.Electricity:
      return "El";
    case AddOn.Insurance:
      return "Försäkring";
    case AddOn.Mortgage:
      return "Bolån";
    default:
      return "Okänd tilläggsprodukt";
  }
};

export const invoiceStatusToString = (status: InvoiceStatus) => {
  switch (status) {
    case InvoiceStatus.NEW:
      return "Ny";
    case InvoiceStatus.SENDING:
      return "Skickar...";
    case InvoiceStatus.SENT:
      return "Skickad";
    default:
      return "Okänd status";
  }
};

export const avyInvoiceStatusToString = (status: AvyInvoiceStatus) => {
  switch (status) {
    case AvyInvoiceStatus.OK:
      return "Skapad";
    case AvyInvoiceStatus.FAILED:
      return "Fel";
    case AvyInvoiceStatus.MISSING:
      return "Ej skickad";
    case AvyInvoiceStatus.SENDING:
      return "Skickar...";
    default:
      return "Ej skickad";
  }
};

export const paymentStatusToString = (status: PaymentStatus): string => {
  switch (status) {
    case PaymentStatus.UNPAID:
      return "Obetald";
    case PaymentStatus.PAID:
      return "Betald";
    case PaymentStatus.ENDED:
      return "Avslutad";
    case PaymentStatus.CREDITED:
      return "Krediterad";
    case PaymentStatus.DELETED:
      return "Makulerad";
    case PaymentStatus.CONFIRMED_LOSS:
      return "Konstaterad kundförlust";
    default:
      return "Okänd status";
  }
};

export const invoiceDeliveryMethodToString = (
  method: InvoiceDeliveryMethod
): string => {
  switch (method) {
    case InvoiceDeliveryMethod.DO_NOT_NOTIFY:
      return "Ingen notifiering";
    case InvoiceDeliveryMethod.EDI:
      return "EDI";
    case InvoiceDeliveryMethod.DYNAMICDISTRIBUTION:
      return "Dynamisk";
    case InvoiceDeliveryMethod.EINVOICE:
      return "E-faktura";
    case InvoiceDeliveryMethod.LETTER:
      return "Brev";
    case InvoiceDeliveryMethod.MAIL:
      return "Epost";
    case InvoiceDeliveryMethod.SMS:
      return "SMS";
    default:
      return "Okänd leveransmetod";
  }
};

export const deliveryStatusToString = (status: Elavtalsstatus): string => {
  switch (status) {
    case Elavtalsstatus.Ny:
      return "Ny";
    case Elavtalsstatus.FullmaktUppskjuten:
      return "Fullmakt uppskjuten";
    case Elavtalsstatus.KlarForFullmakt:
      return "Klar för fullmakt";
    case Elavtalsstatus.KlarForLevbyte:
      return "Klar för leverantörsbyte";
    case Elavtalsstatus.KompletteringPagar:
      return "Komplettering pågår";
    case Elavtalsstatus.FullmaktPagar:
      return "Fullmakt pågår";
    case Elavtalsstatus.LeveransPagar:
      return "Leverans pågår";
    case Elavtalsstatus.LevbytePagar:
      return "Leverantörsbyte pågår";
    case Elavtalsstatus.LevbyteKlart:
      return "Leverantörsbyte klart";
    case Elavtalsstatus.Avbruten:
      return "Avbruten";
    case Elavtalsstatus.KlarForKomplettering:
      return "Klar för komplettering";
    case Elavtalsstatus.KlarForAvtalsService:
      return "Klar för avtalsservice";
    case Elavtalsstatus.AvtalsServicePagar:
      return "Avtalsservice pågår";
    case Elavtalsstatus.KlarForLevFullmakt:
      return "Klar för levfullmakt";
    case Elavtalsstatus.LevFullmaktPagar:
      return "Leverantörsfullmakt pågår";
    case Elavtalsstatus.LeveransAvslutad:
      return "Leverans avslutad";
    default:
      return "Okänd";
  }
};
